type Props = {
    color?: string;
    width?: number;
    height?: number;
};

export default function IconChevronDown({
    color = 'black',
    width = 22,
    height = 22,
}: Props) {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 22 22"
            fill={color}
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="M11 13.73C10.88 13.73 10.76 13.71 10.66 13.67C10.55 13.63 10.45 13.57 10.36 13.47L6.14 9.26C5.97 9.09 5.89 8.88 5.89 8.62C5.89 8.36 5.97 8.14 6.14 7.97C6.31 7.81 6.52 7.72 6.78 7.72C7.04 7.72 7.26 7.81 7.42 7.97L11 11.55L14.57 7.97C14.74 7.81 14.96 7.72 15.22 7.72C15.48 7.72 15.69 7.81 15.86 7.97C16.03 8.14 16.11 8.36 16.11 8.62C16.11 8.88 16.03 9.09 15.86 9.26L11.64 13.47C11.55 13.57 11.45 13.63 11.34 13.67C11.24 13.71 11.12 13.73 11 13.73Z" />
        </svg>
    );
}
